export const siteName = process.env.NEXT_PUBLIC_SITE_NAME || 'Rental Management';
